/**************************************************
 * Nombre:       Formulario_Reserva
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {AccountCircleOutlined, MailOutline, PhoneAndroidOutlined, FlagOutlined} from "@mui/icons-material";
import IngresoCheckGrupoMulti from "../../Modulo_formularios/Componentes/IngresoCheckGrupoMulti";

const Formulario_Reserva = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={AccountCircleOutlined} nombre={'Nombre'} dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={MailOutline} nombre={'Correo'} dato={'correo'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={FlagOutlined} nombre={'Pais'} dato={'pais'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <IngresoTexto Icono={PhoneAndroidOutlined} nombre={'Num Celular'} dato={'celular'} {...props}
                    />
                </Grid>



            </Grid>

        </form>

    )

}
export default Formulario_Reserva